// must stay in sync with MAX_UPLOAD_SIZE_BYTES in the backend upload policy,
// which the presigned link enforces
export const MAX_UPLOAD_SIZE_BYTES = 10 * 1024 * 1024;
